<template>
  <p className="loader">Loading...</p>
</template>
